import { ReactNode } from "react";

/* Prop Types */
interface SelectItemProps {
  value: string;
  children: ReactNode;
  disabled?: boolean;
}

/*
 * SelectItem component
 */
export const SelectItem = ({ value, children, disabled }: SelectItemProps) => (
  /* Render */
  <option value={value} disabled={disabled} className="bg-base-100 text-base-content">
    {children}
  </option>
);
